<template>
  <div class="scene-factory-mobile" :class="classList">

    <MapObject class="scene-factory-mobile__trees" src="/map/mobile_factory_trees.png" :animated="ready" type="trees"></MapObject>
    <MapObject class="scene-factory-mobile__parking" src="/map/mobile_factory_parking.png" :animated="ready" type="trees"></MapObject>

    <MapObject class="scene-factory-mobile__b1" src="/map/build_4f_long_left.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-factory-mobile__b2" src="/map/build_14f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-factory-mobile__b3" src="/map/build_6f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-factory-mobile__b4" src="/map/build_6f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-factory-mobile__b5" src="/map/build_6f.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-factory-mobile__b6" src="/map/build_2f_1.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-factory-mobile__factory" src="/map/factory.png" :animated="ready" type="building"></MapObject>

  </div>
</template>

<script>
  import Scene from './Scene.vue'

  export default {
    extends: Scene,
  }
</script>

<style lang="scss">
  .scene-factory-mobile {
    @include relative-units(384.08px, 376.76px, mobile)
  }

  .scene-factory-mobile__factory{
    left: 8%;
    top: 15%;
    width: 52%;
  }
  .scene-factory-mobile__trees {
    left: 0%;
    top: 7%;
    width: 100%;
  }
  .scene-factory-mobile__parking {
    left: 1%;
    top: 33%;
    width: 68%;
  }
  .scene-factory-mobile__b1 {
    left: 62%;
    top: 0%;
    width: 18%;
  }
  .scene-factory-mobile__b2 {
    left: 82%;
    top: 1%;
    width: 12.4%;
  }
  .scene-factory-mobile__b3 {
    left: 21.6%;
    top: 82.4%;
    width: 12%;
  }
  .scene-factory-mobile__b4 {
    left: 12%;
    top: 88.1%;
    width: 12%
  }
  .scene-factory-mobile__b5 {
    left: 0.4%;
    top: 94%;
    width: 12%;
  }
  .scene-factory-mobile__b6 {
    left: 78.6%;
    top: 64%;
    width: 15%;
  }

</style>
